import React, { Component } from 'react';
import Header from '../../common/header';
import Nav from '../../components/doc-nav';
import s from './index.module.scss';
import { navs_en, navs_zh } from './navs';

import { Redirect, Route, Switch } from 'react-router-dom';

import { BackTop } from 'antd';
import { connect } from 'react-redux';
import mapStateToProps from '../../redux/util';
import MARKDOWN_DATA from '../../qingping-doc/doc-md';
import PlatformDocument from '../doc-pages/PlatformDocument';
import Footer from '../../common/footer';

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navs: '',
    };
  }

  scrollToAnchor() {
    let anchorName = this.props.location.hash;
    // console.log(anchorName, 'anchorName1')
    if (anchorName) {
      anchorName = anchorName.replace('#', '');
      // console.log(decodeURI(anchorName), 'anchorName2')
      let anchorElement = document.getElementById(decodeURI(anchorName));
      // console.log(anchorElement, 'anchorElement')
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  }

  componentDidMount() {
    setTimeout(_ => {
      this.scrollToAnchor();
    }, 100);
  }

  platformDocument = (props, markdownData) => {
    return <PlatformDocument {...props} markdownData={markdownData} />;
  };

  render() {
    const { locale } = this.props;
    const isEn = locale === 'en';
    const marginLeft = isEn ? 330 : 330;
    const navs = isEn ? navs_en : navs_zh;
    const Height = document.body.clientHeight;
    return (<div>
      <Header props={this.props} />
      <div className={s.container}>
        <Nav props={this.props} navs={navs} />
        <div className={s.markdownBody} style={{ minHeight: Height + 160, marginLeft: marginLeft }}>
          <Switch>
            <Route path="/introductions"
              render={props => this.platformDocument(props, MARKDOWN_DATA.platform_manual)} />
            <Route path="/main/guide/snow"
              render={props => this.platformDocument(props, MARKDOWN_DATA.snow_specification)} />
            <Route path="/cloud-to-cloud/product-access-guidelines"
              render={props => this.platformDocument(props, MARKDOWN_DATA.product_specification)} />
            <Route path="/main/guide/dany"
              render={props => this.platformDocument(props, MARKDOWN_DATA.dany_specification)} />
            <Route path="/main/guide/pheasant"
              render={props => this.platformDocument(props, MARKDOWN_DATA.pheasant_specification)} />
            <Route path="/main/bussiness/frog"
              render={props => this.platformDocument(props, MARKDOWN_DATA.frog_specification)} />

            <Route path="/cloud-to-cloud/oauth"
              render={props => this.platformDocument(props, MARKDOWN_DATA.oauth_api)} />
            <Route path="/cloud-to-cloud/open-apis"
              render={props => this.platformDocument(props, MARKDOWN_DATA.open_api)} />
            <Route path="/cloud-to-cloud/data-push"
              render={props => this.platformDocument(props, MARKDOWN_DATA.webhook)} />
            <Route path="/cloud-to-cloud/specification-guidelines"
              render={props => this.platformDocument(props, MARKDOWN_DATA.specification)} />
            <Route path="/cloud-to-cloud/sdk"
              render={props => this.platformDocument(props, MARKDOWN_DATA.cc_sdk)} />

            <Route path="/private/communication-protocols/temp-rh-monitor/lorawan-modbus"
              render={props => this.platformDocument(props, MARKDOWN_DATA.lora_mobbus)} />
            <Route path="/private/communication-protocols/co2-temp-rh-monitor/lorawan-modbus"
              render={props => this.platformDocument(props, MARKDOWN_DATA.lora_mobbus_co)} />
            <Route path="/private/communication-protocols/indoor-environment-monitor/lorawan-modbus"
              render={props => this.platformDocument(props, MARKDOWN_DATA.lora_indoor_modbus)} />
            <Route path="/private/access-instructions"
              render={props => this.platformDocument(props, MARKDOWN_DATA.device_privatization)} />
            <Route path="/private/communication-protocols/public-mqtt-json"
              render={props => this.platformDocument(props, MARKDOWN_DATA.mqtt_protocol)} />
             <Route
              path="/private/communication-protocols/public-mqtt-hex"
              render={() => {
                window.open(isEn ? 'https://qingping.feishu.cn/docx/BlYOdJVRQobV0ox6SNZcV8V6nZT' : 'https://qingping.feishu.cn/docs/doccnsQEUKIl4ySLumxSqYktH4d', '_blank');
                return null;
              }}
            />
            <Route path="/private/air-monitor/access-instructions"
              render={props => this.platformDocument(props, MARKDOWN_DATA.snow_privatization)} />

            <Redirect to="/introductions" />
          </Switch>
        </div>
        <BackTop />
      </div>
      <Footer />
    </div>);
  }
}


export default connect(mapStateToProps)(Main);

